<template>
    <v-card elevation="1">
        <div v-if="hasUsers">
            <v-card class="custom-table-ui header-filters pa-3" flat>
                <v-row>
                    <v-col md="12" lg="12" cols="12" class="mr-auto">
                        <v-text-field v-model="dataTable.search" label="Search here" placeholder="Search here" prepend-inner-icon="search" solo dense flat color="primaryTextColor" clearable hide-details />
                    </v-col>
                </v-row>
            </v-card>
            <v-divider></v-divider>
            <v-data-table
                class="custom-table-ui no-loading-bar"
                v-model="dataTable.selected"
                :show-select="false"
                item-key="id"
                :headers="dataTable.headers"
                :items="dataTable.data"
                :loading="dataTable.loading"
                loader-height="0"
                loading-text="Loading data..."
                :page.sync="dataTable.currentPage"
                :items-per-page.sync="dataTable.itemLength"
                :sort-by.sync="dataTable.sortBy"
                :sort-desc.sync="dataTable.sortDesc"
                :custom-sort="(items) => items"
                hide-default-footer
            >
                <template v-slot:[`item.mobile`]="{ item }">
                    {{ item.mobile | formatPhoneNumber | formatMobileNumber }}
                </template>

                <template v-slot:[`item.last_logged_in_at`]="{ item }">
                    <div v-if="item.last_logged_in_at != ''">
                        {{ item.last_logged_in_at | formatDate }}
                    </div>
                </template>

                <template v-slot:[`item.status`]="{ item }">
                    <div :class="['font-weight-medium status', item.status.toLowerCase()]">{{ item.status | uppercaseFirst }}</div>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    <div class="action">
                        <v-menu min-width="160px">
                            <template v-slot:activator="{ on: menu, attrs }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on: tooltip }">
                                        <v-icon class="float-right" v-bind="attrs" v-on="{ ...tooltip, ...menu }">mdi-dots-vertical</v-icon>
                                    </template>
                                    <span>More</span>
                                </v-tooltip>
                            </template>

                            <v-list>
                                <v-list-item v-if="isPermitted(userInfo.permissions, 'cms_users-show')" @click="viewDetails(item.id)" dense>View Details</v-list-item>
                                <v-list-item v-if="isPermitted(userInfo.permissions, 'cms_users-update')" @click="editDetails(item.id)" dense>Edit Details</v-list-item>
                                <v-list-item
                                    dense
                                    @click="
                                        confirmAction({
                                            action: 'change-status',
                                            data: item
                                        })
                                    "
                                    v-if="item.status != 'INVITED'"
                                >
                                    {{ item.status == 'ACTIVE' ? 'Deactivate' : 'Activate' }}
                                </v-list-item>
                                <v-list-item
                                    v-if="isPermitted(userInfo.permissions, 'cms_users-destroy')"
                                    class="error--text"
                                    @click="
                                        confirmAction({
                                            action: 'delete',
                                            data: item
                                        })
                                    "
                                    dense
                                >
                                    Delete
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </template>
            </v-data-table>

            <v-card class="data-table-footer d-flex align-center justify-space-between flex-wrap border-radius-10 py-0" flat color="primaryBackgroundColor">
                <div class="flex-md-grow-0 flex-sm-grow-0 flex-grow-1 d-flex align-center justify-center py-2 px-3">
                    <span>Show</span>
                    <v-select class="item-length mx-2" v-model="dataTable.itemLength" :items="[10, 20, 50, 100]" solo dense flat background-color="secondaryBackgroundColor" hide-details />
                    <span class="px-0" md="auto" sm="auto" cols="auto">items per page</span>
                </div>
                <v-pagination class="flex-md-grow-0 flex-sm-grow-0 flex-grow-1 justify-center py-2" v-model="dataTable.currentPage" :length="dataTable.totalPages" :total-visible="7"></v-pagination>
            </v-card>
        </div>
        <div v-else class="user-empty d-flex align-center justify-center text-center pa-10">
            <div>
                <v-icon large>mdi-account-supervisor</v-icon>
                <div class="font-weight-bold">There are no Users to display.</div>
                <small>You’ve not added any user yet.</small>
            </div>
        </div>

        <AppModal :confirm-dialog="confirmDialog" :confirm-status-loading="confirmStatusLoading" @modalAction="modalAction" />
    </v-card>
</template>

<script>
import AppModal from '@/components/Core/AppModal.vue';

export default {
    name: 'UsersDataTable',
    components: {
        AppModal
    },
    data() {
        return {
            hasUsers: true,
            onload: true,
            dataTable: {
                loading: true,
                search: '',
                itemLength: 10,
                currentPage: 1,
                totalPages: 1,
                selected: [],
                sortBy: [],
                sortDesc: [],
                headers: [
                    { text: 'Name', value: 'full_name' },
                    { text: 'Email Address', value: 'email' },
                    { text: 'Mobile Number', value: 'mobile' },
                    { text: 'Role', value: 'role_name' },
                    { text: 'Last Access', value: 'last_logged_in_at' },
                    { text: 'Status', value: 'status', width: '150px' },
                    {
                        text: '',
                        value: 'actions',
                        sortable: false,
                        class: ['sticky', 'right'],
                        cellClass: ['sticky', 'right'],
                        width: '50px',
                        align: 'center'
                    }
                ],
                data: []
            },
            confirmDialog: { show: false, action: '', data: {}, status: '' },
            confirmStatusLoading: false
        };
    },
    created() {
        this.getData({ cancel_current_api_call: true });
    },
    computed: {
        list() {
            return this.$store.getters['users/getUsersList'];
        }
    },
    watch: {
        list(to) {
            if (to) {
                this.setTableDetails(to);
                window.scrollTo(0, 0);
                this.onload = false;
            }
        },
        'dataTable.itemLength'() {
            this.dataTable.currentPage = 1;
            this.getData({ cancel_current_api_call: true });
        },
        'dataTable.currentPage'() {
            this.getData({ cancel_current_api_call: true });
        },
        'dataTable.search'() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.dataTable.currentPage = 1;
                this.getData({ cancel_current_api_call: true });
            }, 300);
        },
        'dataTable.sortBy'() {
            const sortBy = this.dataTable.sortBy[0],
                sortDesc = this.dataTable.sortDesc[0];
            if (sortBy != undefined && sortDesc != undefined && sortDesc != true) {
                this.getData({ cancel_current_api_call: true });
            } else if (sortBy == undefined && sortDesc == undefined) {
                this.getData({ cancel_current_api_call: true });
            }
        },
        'dataTable.sortDesc'() {
            const sortBy = this.dataTable.sortBy[0],
                sortDesc = this.dataTable.sortDesc[0];
            if (sortBy != undefined && sortDesc != undefined) {
                this.getData({ cancel_current_api_call: true });
            } else if (sortBy == undefined && sortDesc == undefined) {
                this.getData({ cancel_current_api_call: true });
            }
        }
    },
    methods: {
        // View details
        viewDetails(id) {
            this.$router.push({ name: 'user-access-action', params: { action: 'view', id: id } });
        },
        // Edit details
        editDetails(id) {
            this.$router.push({ name: 'user-access-action', params: { action: 'edit', id: id } });
        },
        // Modal confirmation
        confirmAction({ action, data }) {
            switch (action) {
                case 'delete':
                    data.modalTitle = `Are you sure you want to delete user ${data.full_name}?`;
                    data.modalDescription = 'Deleting will remove this account and all of the information of this account.';
                    this.confirmDialog = { show: true, action, data };
                    break;

                case 'change-status':
                    if (!data.is_active) {
                        data.modalTitle = `Are you sure you want to activate user ${data.full_name}?`;
                        data.modalDescription = 'Activating will enable this account and this user will be able to create merchant accounts.';
                    } else {
                        data.modalTitle = `Are you sure you want to deactivate user ${data.full_name}?`;
                        data.modalDescription = 'Deactivating will disable this account and this user will not be able to login.';
                    }

                    this.confirmDialog = { show: true, action, data: { ...data, is_active: !data.is_active } };
                    break;
            }
        },
        // Exec modal action
        modalAction({ action, data }) {
            data.confirmation = 0;

            switch (action) {
                case 'delete':
                    data.confirmation = 1;
                    this.deleteUser(data);
                    break;

                case 'change-status':
                    this.updateUser(data);
                    break;

                case 'cancel':
                    this.confirmDialog.show = false;
                    break;
            }
        },
        // Get datatable details
        getData(payload) {
            let { cancel_current_api_call } = payload || {};

            if (cancel_current_api_call) {
                this.$api.cancelCurrentApiCall();
            }

            this.dataTable.loading = true;

            const { search, itemLength, currentPage, sortBy, sortDesc } = this.dataTable;

            this.$store
                .dispatch('users/fetchUsers', {
                    config: {
                        params: {
                            'appends[]': 'role_name',
                            'filters[keyword]': search || undefined,
                            per_page: itemLength,
                            page: currentPage,
                            sort_by: sortBy[0] == 'full_name' ? 'first_name' : sortBy[0],
                            order: sortDesc[0] != undefined ? (!sortDesc[0] ? 'asc' : 'desc') : undefined
                        }
                    }
                })
                .catch(() => {
                    this.dataTable.loading = false;
                });
        },
        // Set datatable details
        setTableDetails(response) {
            this.dataTable.loading = false;
            this.hasUsers = this.onload && response.meta.total == 0 ? false : true;
            this.dataTable.data = response.data;
            this.dataTable.totalPages = response.meta.last_page;
        },
        // Delete user
        deleteUser(data) {
            this.confirmStatusLoading = true;

            this.$store
                .dispatch('users/deleteUser', {
                    id: data.id,
                    config: {
                        params: {
                            confirmation: data.confirmation
                        }
                    }
                })
                .then((response) => {
                    this.notification({ type: 'success', message: response.message });
                    this.getData({ cancel_current_api_call: true });
                    this.confirmDialog.show = false;
                    this.confirmStatusLoading = false;
                })
                .catch(() => {
                    this.confirmStatusLoading = false;
                });
        },
        // Update user
        updateUser(data) {
            this.confirmStatusLoading = true;

            this.$store
                .dispatch('users/updateUser', {
                    id: data.id,
                    config: {
                        params: {
                            status: data.is_active ? 'ACTIVE' : 'INACTIVE'
                        }
                    }
                })
                .then((response) => {
                    this.notification({ type: 'success', message: response.message });
                    this.getData({ cancel_current_api_call: true });
                    this.confirmDialog.show = false;
                    this.confirmStatusLoading = false;
                })
                .catch(() => {
                    this.confirmStatusLoading = false;
                });
        }
    }
};
</script>

<style lang="scss" scoped>
.user-empty {
    min-height: 300px;
}

.v-menu__content .v-list .v-list-item {
    color: #425466;
}

::v-deep table {
    color: #425466 !important;

    tr {
        th {
            color: #8492a6 !important;
        }

        td:first-child {
            font-weight: 600;
        }
    }
}
</style>
